import { IQuyetDinhHocVu } from "../../model/response/xet-hoc-vu/IQuyetDinhHocVu";
import { apiClient } from "../apiClient";

export const QUYET_DINH_HOC_VU_ENDPOINT = "quyet-dinh-hoc-vu";
export const quyetDinhHocVuApi = {
    GetListByDotXet: (id_dot_xet: number) => apiClient.get(`${QUYET_DINH_HOC_VU_ENDPOINT}/dot-xet/${id_dot_xet}`),
    GetSinhVien: (id_quyet_dinh: number) => apiClient.get(`${QUYET_DINH_HOC_VU_ENDPOINT}/${id_quyet_dinh}/sinh-vien`),
    Insert: (data: IQuyetDinhHocVu) => apiClient.post(`${QUYET_DINH_HOC_VU_ENDPOINT}`, data),
    Update: (id: number, data: IQuyetDinhHocVu) => apiClient.put(`${QUYET_DINH_HOC_VU_ENDPOINT}/${id}`, data),
    Delete: (id: number) => apiClient.delete(`${QUYET_DINH_HOC_VU_ENDPOINT}/${id}`),
    DongBoKetQua: (id_quyet_dinh: number) => apiClient.post(`${QUYET_DINH_HOC_VU_ENDPOINT}/${id_quyet_dinh}/dong-bo-ket-qua`),
    AddSinhVien: (id_quyet_dinh: number, ids: string[]) => apiClient.post(`${QUYET_DINH_HOC_VU_ENDPOINT}/${id_quyet_dinh}/sinh-vien`, { ids }),
    RemoveSinhVien: (ids: number[]) => apiClient.post(`${QUYET_DINH_HOC_VU_ENDPOINT}/sinh-vien/xoa`, { ids }),
}
